export const ADS_CONFIG_RULES = {
  maxImageSize: parseInt(
    process.env.REACT_APP_CAMPAIGN_MAX_IMAGE_SIZE ||
    process.env.REACT_APP_DEFAULT_MAX_IMAGE_SIZE ||
    "100"
  ),
};
